var _a;
import { createTV, defaultConfig, } from 'tailwind-variants';
import resolveConfig from 'tailwindcss/resolveConfig';
import { tailwindConfig } from '@/style/config';
const fullConfig = resolveConfig(tailwindConfig);
// クラスを取得
const getTargetThemeClass = (themeKey) => {
    const targetTheme = fullConfig.theme[themeKey] || {};
    return Object.entries(targetTheme).map(([key, value]) => typeof value === 'object' && value !== null && !Array.isArray(value)
        ? { [key]: Object.keys(value) }
        : key);
};
/**
 * tailwind variant 内部の tailwind-merge 設定
 */
const twMergeConfig = Object.assign(Object.assign({}, defaultConfig.twMergeConfig), { classGroups: {
        'font-family': [{ font: getTargetThemeClass('fontFamily') }],
        'font-size': [{ text: getTargetThemeClass('fontSize') }],
        'font-weight': [{ font: getTargetThemeClass('fontWeight') }],
        'text-color': [{ text: getTargetThemeClass('textColor') }],
    }, conflictingClassGroups: Object.assign(Object.assign({}, (((_a = defaultConfig === null || defaultConfig === void 0 ? void 0 : defaultConfig.twMergeConfig) === null || _a === void 0 ? void 0 : _a.conflictingClassGroups) || {})), { 
        // font-size と line-height が同時に指定された場合 line-height がマージされないようにする
        // https://github.com/dcastil/tailwind-merge/issues/218
        'font-size': undefined }) });
/**
 * tailwind variant 管理ライブラリのラッパー
 * @note ディレクトリを移動した際は tailwind.config.js の aliases を修正してください
 * https://www.tailwind-variants.org/docs/variants
 */
export const tv = createTV({
    twMerge: true,
    twMergeConfig,
});
